import axios from 'axios'
import router from '@/router'

axios.interceptors.request.use(
  function (config) {
    config.headers['X-Token'] = localStorage.getItem("X-Token");

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      alert(error.response.data.message)
      router.push('/')
    }

    return Promise.reject(error);
  }
);

export default axios
